import { jsx as c } from "react/jsx-runtime";
import { ComboboxInput as b } from "@headlessui/react";
import { twMerge as f } from "tailwind-merge";
import { FONT_SIZE_CLASS_NAME as x, FORM_ELEMENT_PADDING_CLASS_NAME as y } from "../../../constants/base-class-name.mjs";
import { useTranslation as _ } from "../../../i18n/hooks.mjs";
function M({
  isDisabled: o,
  open: a,
  hasError: i,
  className: n,
  placeholder: s,
  selectedCaption: t,
  isPreFetching: l,
  onFocus: p,
  onChange: r,
  inputRef: m,
  dataTest: d
}) {
  const { t: u } = _();
  return /* @__PURE__ */ c(
    b,
    {
      ref: m,
      className: f(
        "w-full truncate",
        x,
        "flex items-center justify-between",
        y,
        "rounded-lg pr-14",
        "text-text-primary placeholder:text-text-tertiary/70 cursor-default",
        "focus-visible:border-brand-primary border focus:outline-hidden",
        "main-transition-colors",
        o ? "bg-skeleton-primary/20" : "bg-background-secondary",
        a ? "border-brand-primary" : i ? "border-danger" : "border-text-secondary/30",
        l && ["animate-pulse", "text-transparent placeholder:text-transparent"],
        n
      ),
      onChange: (e) => r == null ? void 0 : r(e.target.value),
      onKeyDown: (e) => e.stopPropagation(),
      onFocus: p,
      displayValue: t ? () => t : void 0,
      placeholder: s ?? u("public_pages_purchase.form_select.select"),
      ...d
    }
  );
}
export {
  M as FormSelectInput
};
